export default "__VITE_ASSET__BxnwUZA0__"